export default __webpack_public_path__ + "static/media/lostSound.0242c96f.wav";